var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 52,
    viewBox: "0 0 16 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29289 51.5636C7.68342 51.9541 8.31658 51.9541 8.7071 51.5636L15.0711 45.1996C15.4616 44.8091 15.4616 44.1759 15.0711 43.7854C14.6805 43.3949 14.0474 43.3949 13.6569 43.7854L8 49.4422L2.34314 43.7854C1.95262 43.3949 1.31945 43.3949 0.92893 43.7854C0.538406 44.1759 0.538406 44.8091 0.92893 45.1996L7.29289 51.5636ZM7 0.856445L7 50.8564L9 50.8564L9 0.856445L7 0.856445Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrArrowDown);
export default __webpack_public_path__ + "static/media/ubr-arrow-down.fd411477814c05912cd4e9920d73d502.svg";
export { ForwardRef as ReactComponent };